export const tracks = [
  {
    title: "Track 1",
    name: "Quantum Theory & Foundations",
    items: [
      "Quantum Computing Theory & Algorithms",
      "Quantum Information Theory",
      "Quantum Entanglement & Teleportation"
    ],
  },
  {
    title: "Track 2",
    name: "Quantum Communication & Networking",
    items: [
      "Quantum Communication & Cryptography",
      "Quantum Networks and Internet"
    ],
  },
  {
    title: "Track 3",
    name: "Quantum Systems & Hardware",
    items: [
      "Quantum Hardware, Devices, and Architectures",
      "Quantum Error Correction & Fault Tolerance"
    ],
  },
  {
    title: "Track 4",
    name: "Quantum Intelligence & Simulation",
    items: [
      "Quantum Machine Learning & Artificial Intelligence",
      "Quantum Simulation and Modeling"
    ],
  },
  {
    title: "Track 5",
    name: "Applications of Quantum Technologies in Industry",
    items: [
      "Quantum computing in Finance",
      "Quantum Applications in Healthcare & Drug Discovery",
      "Quantum Technologies for Materials Science & Chemistry",
      "Quantum Optimization in Logistics & Supply Chain",
      "Quantum Applications in Energy Systems",
      "Quantum Sensing & Metrology",
      "Quantum Applications in Cybersecurity & Risk Management",
      "Quantum Technologies for Climate Modeling & Sustainability",
      "Hybrid Quantum-Classical Applications in Real-World Systems"
    ],
  },
];

export const dates = [
  { label: "Abstract Submission Date: ", date: "2027-02-10" },
  { label: "Full Paper Submission Date:", date: "2027-02-10" },
  { label: "Notification of Acceptance Date", date: "2027-04-30" },
  { label: "Final Camera Ready Paper Submission Date", date: "2027-05-30" },
  { label: "Last Date for Registration", date: "2027-07-15" },
  { label: "Conference Date", date: "2027-09-24 & 2027-09-25" },
];

export const SUBMISSION_LINK = "https://cmt3.research.microsoft.com/ICCUBEA2026";
